import React from "react";
import {sendContactsMessage} from "../../util/contacts_api_utils";
import { formatPhoneNumber } from "../../util/easy_format_utils";
import { trackTourEvent } from "../../util/tour_events_api_util";

class PropertyTourContactForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      message: '',
      sent: false,
      loading: false,
      error: ''
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onInputChange(field) {
    return (e) => {
      let value = e.target.value;

      // Only strip non-digits if the field is a phone number
      if (field.includes('phone')) {
        value = value.replace(/\D/g, '');
      }

      this.setState({ [field]: value });
    };
  }

  onSubmit(e) {
    e.preventDefault()
    if (this.state.loading) return
    const {loading, sent, error, ...payload} = this.state
    this.setState({sent: false, loading: true, error: ''})

    sendContactsMessage({...payload, project_id: this.props.project?.id}).then(() => {
      trackTourEvent(this.props.project?.id, "contact_form", {
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        email: this.state.email,
        phone: this.state.phone,
        message: this.state.message,
      })
      this.setState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        message: '',
        sent: true,
        loading: false
      })
    }).catch(response => {
      this.setState({loading: false, error: response?.responseJSON?.join('. ') || 'Your message could not be sent. Please try again.'})
    })
  }

  render() {
    return <form onSubmit={this.onSubmit}>
      {this.state.error && <div className="alert alert-danger" role="alert">{this.state.error}</div>}
      {this.state.sent && <div className="alert alert-success mb-4">Your message has been sent</div>}

      <div className="row">
        <div className="col-12 col-md-6">
          <div className="inputGroup">
            <label className="required">First name</label>
            <input className="formInput" placeholder="" onChange={this.onInputChange('first_name')}
                   value={this.state.first_name} required/>
          </div>
        </div>

        <div className="col-12 col-md-6">
          <div className="inputGroup">
            <label className="required">Last name</label>
            <input className="formInput" placeholder="" onChange={this.onInputChange('last_name')}
                   value={this.state.last_name} required/>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="inputGroup">
            <label className="required">Email address</label>
            <input className="formInput" placeholder="" onChange={this.onInputChange('email')}
                   value={this.state.email} required type="email"/>
          </div>
        </div>

        <div className="col-12 col-md-6">
          <div className="inputGroup">
            <label>Phone number</label>
            <input className="formInput" placeholder="" onChange={this.onInputChange('phone')}
                   value={formatPhoneNumber(this.state.phone)}/>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="inputGroup">
            <label>Your Message</label>
            <textarea className="formInput" placeholder="" onChange={this.onInputChange('message')}
                      value={this.state.message} style={{minHeight: '85px'}} required/>
          </div>
        </div>
      </div>
      <div>
        <button className="contactsSubmitBtn" type="submit" disabled={this.state.loading}>
          Submit
        </button>
      </div>
    </form>
  }
}

export default PropertyTourContactForm
